import CommonPopup from "@/components/CommonPopup";
import { useUsersShowCreateDialog, useUsersTableActions } from "@/stores/use-users-table";

import UserCreateDialog from "./userCreateDialog";

function UserCreateComp() {
    const showCreateDialog = useUsersShowCreateDialog();
    const { updateShowCreateDialog } = useUsersTableActions();
    const onClose = () => {
        updateShowCreateDialog(false);
    };
    return (
        <CommonPopup title={"Kullanıcı Oluştur"} open={showCreateDialog} size="sm" onClose={onClose}>
            <UserCreateDialog />
        </CommonPopup>
    );
}

export default UserCreateComp;
